import styled, { css } from 'styled-components';
import { Orientation } from '../../utils/consts';

export const RadioGroupContainer = styled.div.attrs({ className: 'dsc-radioGroup' })`
  && {
    display: flex;
    gap: 10px;
    .MuiFormGroup-root {
      flex-direction: ${({ $orientation }) => ($orientation === Orientation.HORIZONTAL ? 'row' : 'column')};
    }

    .MuiTypography-root {
      font-size: 12px;
      color: var(--label-color);
    }

    ${({ checked }) =>
      !checked &&
      css`
        .MuiRadio-root {
          font-size: var(--control-size, 24px);
          .dsc-icon-wrapper {
            font-size: var(--control-size, 24px);
          }
          :not(.Mui-checked):hover {
            svg {
              stroke: var(--control-hover-border, var(--midnightGreen));
            }
          }
        }
      `}

    .MuiFormControlLabel-label {
      font-size: 13px;
      font-family: var(--app-font) Averta, sans-serif;
    }
  }
`;
export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`;
